
import React, { useEffect, useState } from "react";
// import React from "react";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
// import Header from "../../components/Header/Header";
import Header from "../../components/Header/Header";

import axios from "axios";
import MyAgGridTable from "./MyAgGridTable";
import MyTable from "./MyTable"
const useStyles = makeStyles((theme) => ({
  button: {
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.73rem", // Decrease font size for small screens
      padding: theme.spacing(1, 4), // Decrease button padding for small screens
    },
  },

}));


function Layout({ open }) {

  const [formDataLength, setFormDataLength] = useState(0);
  const [candidataState, setCandidataState] = useState(null);

  useEffect(() => {
    axios
      .get("https://backend.form-seef.com/api/get-forms")
      .then((res) => {
        if (res) {
          setFormDataLength(res.data.data.length);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleCandidatesAppliedClick = () => {
    setCandidataState("Candidates Applied");
  };



  const classes = useStyles();
  const navigate = useNavigate();

  const handleApply = () => {
    navigate("/form");
  };


  return (
    <>
      <div className="" style={{ width: open ? "88%" : "100%", margin:"20px auto"}}>
        <Header />
      </div>
      <div
        className="pt-8 sm:h-screen bg-gray-200 shadow-2xl shadow-slate-800 px-6 sm:px-20 rounded-md mt-16"
        // style={{ width: open ? "95%" : "100%" }}
        style={{ width: "95%", margin:"auto" }}
      >
        {/* <div className="py-20">

        <p className="flex flex-col rounded-2xl bg-white text-center justify-center p-6  sm:p-20 text-2xl sm:text-4xl font-semibold">
          WELCOME TO THE ADMIN PANEL OF SINDH EDUCATIONAL ENDOWMENT FUND
        </p>
        </div>
        <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            fullWidth
            onClick={handleApply}
          >
            Apply Online for Scholarship
          </Button> */}
     <div className="flex flex-col items-center justify-center mt-2">
       <div
        onClick={handleCandidatesAppliedClick}
        className="bg-white rounded-lg shadow-md p-4 hover:transform hover:-translate-y-2 hover:bg-slate-300 hover:transition hover:duration-300 hover:ease-in-out flex flex-col items-center cursor-pointer"
      >
        {formDataLength ? (
          <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
            {formDataLength}
          </div>
        ) : (
          <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
            Loading...
          </div>
        )}

        <div className="p-2 text-center">
          <h2 className="font-bold mb-2">Candidates Applied</h2>
          <p className="text-gray-700 text-base">Total Applications Received</p>
        </div>
      </div>

      {/* {candidataState === "Candidates Applied" && ( */}
        <div className="w-full">
          <MyAgGridTable />
        </div>
      {/* )} */}
    </div>
          {/* <MyTable /> */}

      </div>
    </>
  );
}

export default Layout;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import MyAgGridTable from "./MyAgGridTable";

// function Main() {
//   const [formDataLength, setFormDataLength] = useState(0);
//   const [candidataState, setCandidataState] = useState(null);

//   useEffect(() => {
//     axios
//       .get("https://backend.form-seef.com/api/get-forms")
//       .then((res) => {
//         if (res) {
//           setFormDataLength(res.data.data.length);
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }, []);

//   const handleCandidatesAppliedClick = () => {
//     setCandidataState("Candidates Applied");
//   };

//   return (
//     <div className="flex flex-col items-center justify-center mt-2">
//       <div
//         onClick={handleCandidatesAppliedClick}
//         className="bg-white rounded-lg shadow-md p-4 hover:transform hover:-translate-y-2 hover:bg-slate-300 hover:transition hover:duration-300 hover:ease-in-out flex flex-col items-center cursor-pointer"
//       >
//         {formDataLength ? (
//           <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
//             {formDataLength}
//           </div>
//         ) : (
//           <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
//             Loading...
//           </div>
//         )}

//         <div className="p-2 text-center">
//           <h2 className="font-bold mb-2">Candidates Applied</h2>
//           <p className="text-gray-700 text-base">Total Applications Received</p>
//         </div>
//       </div>

//       {candidataState === "Candidates Applied" && (
//         <div className="w-full">
//           <MyAgGridTable />
//         </div>
//       )}
//     </div>
//   );
// }

// export default Main;
